import { ImageEditorOptions } from '@uppy/image-editor';
import { UploaderVariant } from 'shared/enums';

const DEFAULT_OPTIONS = {
  actions: {
    revert: true,
    rotate: true,
    granularRotate: true,
    flip: true,
    zoomIn: true,
    zoomOut: true,
    cropSquare: false,
    cropWidescreen: false,
    cropWidescreenVertical: false,
  },
};

const USER_AVATAR_IMAGE_EDITOR_OPTIONS = {
  ...DEFAULT_OPTIONS,
  cropperOptions: { aspectRatio: 1, croppedCanvasOptions: {} },
};

export const IMAGE_EDITOR_VARIANTS: Record<UploaderVariant, ImageEditorOptions> = {
  [UploaderVariant.UserAvatar]: USER_AVATAR_IMAGE_EDITOR_OPTIONS,
  [UploaderVariant.AdminUserAvatar]: USER_AVATAR_IMAGE_EDITOR_OPTIONS,
  [UploaderVariant.TournamentBanner]: {
    cropperOptions: { aspectRatio: 5.8, croppedCanvasOptions: {} },
    ...DEFAULT_OPTIONS,
  },
  [UploaderVariant.TournamentCard]: {
    cropperOptions: { aspectRatio: 3.18, croppedCanvasOptions: {} },
    ...DEFAULT_OPTIONS,
  },
};
